import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getAllMetadataProfilesFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.metadataProfileUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllMetadataProfileFromServer][Store][Error occured while getting metadata profile List--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewMetadataProfile(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.metadataProfileUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewMetadataProfile][Store][Metadata profile add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewMetadataProfile][Store][Error occured while adding metadata profile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateExistingMetadataProfile(context, payload = {}) {
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.put(`${Constants.metadataProfileUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingMetadataProfile][Store][MetadataProfile update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingMetadataProfile][Store][Error occured while updating MetadataProfile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteExistingMetadataProfile(context, payload = {}) {
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.metadataProfileUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingMetadataProfile][Store][MetadataProfile Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingMetadataProfile][Store][Error occured while deleting MetadataProfile--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getMetadataProfileInfoFromServer(context, payload = {}) {
    //payload : {params:{metadataProfileId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.metadataProfileUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getMetadataProfileInfoFromServer][Store][Error occured while getting Metadata profile info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
};
